import React from "react";

const Tabs = props => {
    const { children, onClick, activeTabId, errors = [], formMeta } = props;

    const hasErrors = tab => {
        return tab.inputs.some(
            input => !!errors[input] && formMeta && formMeta[input] && formMeta[input].touched
        );
    };

    const getClassNames = tab => {
        let active = "";
        if (tab.id === activeTabId) {
            active = "active ";
        }

        let tabClasses = "nav-link " + active;
        if (hasErrors(tab)) {
            tabClasses = tabClasses + " tab-with-errors";
        }

        return tabClasses;
    };

    const renderActiveTab = () => {
        return children.map(childElem => {
            if (childElem.props.id === activeTabId) {
                return (
                    <div
                        key={childElem.props.id}
                        className="active-tab-content"
                    >
                        {childElem}
                    </div>
                );
            }

            return (
                <div
                    key={childElem.props.id}
                    className="inactive-tab-content"
                    style={{ display: 'none' }}
                >
                    {childElem}
                </div>
            );
        });
    };

    return (
        <div className="Tabs" data-cy-form-tabs-container="formTabsContainer">
            <ul className="nav nav-tabs " role="tablist">
                {children.map(tab => {
                    return (
                        <li key={tab.props.id} className="nav-item">
                            <a
                                className={getClassNames(tab.props)}
                                data-toggle="tab"
                                href={tab.props.href}
                                data-cy-company-form-tab={tab.props.id}
                                role="tab"
                                onClick={onClick.bind(null, tab.props)}
                            >
                                {tab.props.title}
                            </a>
                        </li>
                    );
                })}
            </ul>
            <div className="tab-content">{renderActiveTab()}</div>
        </div>
    );
};

export default Tabs;



// WEBPACK FOOTER //
// ./web/src/components/company/company-form/Tabs.jsx